'use client';

import Link from 'next/link';
import { useAuth } from '@/lib/auth/context';

/**
 * Auth-aware "Start Free" CTA used across the redesigned homepage/courts nav,
 * hero, and final-CTA sections (design_handoff_homepage_and_courts). Signed-in
 * visitors go straight to their dashboard instead of the signup copy/link.
 */
export default function StartFreeButton({
  className,
  onClick,
  unauthenticatedLabel = 'Start Free',
}: {
  className?: string;
  onClick?: () => void;
  unauthenticatedLabel?: string;
}) {
  const { isAuthenticated } = useAuth();
  const href = isAuthenticated ? '/dashboard' : '/login?intent=signup&redirect=/dashboard';
  const label = isAuthenticated ? 'Go to Dashboard' : unauthenticatedLabel;

  return (
    <Link href={href} className={className} onClick={onClick}>
      {label} <span aria-hidden="true">&rarr;</span>
    </Link>
  );
}
